import page from './page.js'


export default page;


// WEBPACK FOOTER //
// ./src/store/page/index.js